import request from '@/plugins/axios'

// ==================== 服务管理 API ====================
// 服务列表
export const apiServiceLists = (params?: any) => request.get('/service.service/lists', { params })

// 服务详情
export const apiServiceDetail = (params: any) => request.get('/service.service/detail', { params })

// 添加服务
export const apiServiceAdd = (params: any) => request.post('/service.service/add', params)

// 编辑服务
export const apiServiceEdit = (params: any) => request.post('/service.service/edit', params)

// 删除服务
export const apiServiceDelete = (params: any) => request.post('/service.service/del', params)

// 启用/停用服务
export const apiServiceStatus = (params: any) => request.post('/service.service/status', params)

// ==================== 流程管理 API ====================
// 流程定义列表
export const apiProcessDefinitionList = (params?: any) => request.get('/process.definition/lists', params)

// 流程定义详情
export const apiProcessDefinitionDetail = (params: any) => request.get('/process.definition/detail', { params })

// 添加流程定义
export const apiProcessDefinitionAdd = (params: any) => request.post('/process.definition/add', params)

// 编辑流程定义
export const apiProcessDefinitionEdit = (params: any) => request.post('/process.definition/edit', params)

// 删除流程定义
export const apiProcessDefinitionDelete = (params: any) => request.post('/process.definition/del', params)

// 启用/停用流程定义
export const apiProcessDefinitionStatus = (params: any) => request.post('/process.definition/status', params)

// 设置默认流程
export const apiProcessDefinitionSetDefault = (params: any) => request.post('/process.definition/setDefault', params)

// 复制流程定义
export const apiProcessDefinitionCopy = (params: any) => request.post('/process.definition/copy', params)

// 版本管理
export const apiProcessDefinitionVersionList = (params: any) => request.get('/process.definition/versionList', { params })

// 发布新版本
export const apiProcessDefinitionPublish = (params: any) => request.post('/process.definition/publish', params)

// ==================== 流程节点 API ====================
// 节点列表
export const apiProcessNodeList = (params: any) => request.get('/process.node/lists', { params })

// 节点详情
export const apiProcessNodeDetail = (params: any) => request.get('/process.node/detail', { params })

// 添加节点
export const apiProcessNodeAdd = (params: any) => request.post('/process.node/add', params)

// 编辑节点
export const apiProcessNodeEdit = (params: any) => request.post('/process.node/edit', params)

// 删除节点
export const apiProcessNodeDelete = (params: any) => request.post('/process.node/del', params)

// 批量保存节点
export const apiProcessNodeBatchSave = (params: any) => request.post('/process.node/batchSave', params)

// 节点排序
export const apiProcessNodeSort = (params: any) => request.post('/process.node/sort', params)

// ==================== 流程实例 API ====================
// 流程实例列表
export const apiProcessInstanceList = (params?: any) => request.get('/process.instance/lists', params)

// 流程实例详情
export const apiProcessInstanceDetail = (params: any) => request.get('/process.instance/detail', { params })

// 终止流程实例
export const apiProcessInstanceTerminate = (params: any) => request.post('/process.instance/terminate', params)

// 挂起/恢复流程实例
export const apiProcessInstanceSuspend = (params: any) => request.post('/process.instance/suspend', params)

// 流程实例节点记录
export const apiProcessInstanceNodeLog = (params: any) => request.get('/process.instance/nodeLog', { params })

// ==================== 流程审批 API ====================
// 审批记录列表
export const apiProcessApprovalList = (params?: any) => request.get('/process.approval/lists', params)

// 审批记录详情
export const apiProcessApprovalDetail = (params: any) => request.get('/process.approval/detail', { params })

// 提交审批
export const apiProcessApprovalSubmit = (params: any) => request.post('/process.approval/submit', params)

// 转交审批
export const apiProcessApprovalTransfer = (params: any) => request.post('/process.approval/transfer', params)

// 撤回审批
export const apiProcessApprovalWithdraw = (params: any) => request.post('/process.approval/withdraw', params)

// 审批统计
export const apiProcessApprovalStats = (params: any) => request.get('/process.approval/stats', { params })

// ==================== 流程相关工具 API ====================
// 获取可用的处理人
export const apiProcessGetHandlers = (params: any) => request.get('/process.tools/getHandlers', { params })

// 获取角色列表
export const apiProcessGetRoles = (params?: any) => request.get('/process.tools/getRoles', params)

// 获取用户列表
export const apiProcessGetUsers = (params?: any) => request.get('/process.tools/getUsers', params)

// 验证流程定义
export const apiProcessValidate = (params: any) => request.post('/process.tools/validate', params)

// 导入/导出流程定义
export const apiProcessExport = (params: any) => request.get('/process.tools/export', {
  params,
  responseType: 'blob'
})

export const apiProcessImport = (params: any) => request.post('/process.tools/import', params, {
  headers: { 'Content-Type': 'multipart/form-data' }
})

// ==================== 工单类型 API ====================
// 工单类型列表
export const apiWorkOrderTypeList = (params?: any) => request.get('/work_order.type/lists', params)

// 工单类型详情
export const apiWorkOrderTypeDetail = (params: any) => request.get('/work_order.type/detail', { params })

// 添加工单类型
export const apiWorkOrderTypeAdd = (params: any) => request.post('/work_order.type/add', params)

// 编辑工单类型
export const apiWorkOrderTypeEdit = (params: any) => request.post('/work_order.type/edit', params)

// 删除工单类型
export const apiWorkOrderTypeDelete = (params: any) => request.post('/work_order.type/del', params)

// 启用/停用工单类型
export const apiWorkOrderTypeStatus = (params: any) => request.post('/work_order.type/status', params)

// 获取所有工单类型（下拉框）
export const apiWorkOrderTypeAll = (params?: any) => request.get('/work_order.type/all', params)

// ==================== 关联API ====================
// 获取服务可选的流程定义
export const apiServiceProcessOptions = (params: any) => request.get('/service.service/processOptions', { params })

// 获取流程定义可用的服务
export const apiProcessServiceOptions = (params: any) => request.get('/process.definition/serviceOptions', { params })

// 绑定流程定义到服务
export const apiServiceBindProcess = (params: any) => request.post('/service.service/bindProcess', params)

// 解绑流程定义
export const apiServiceUnbindProcess = (params: any) => request.post('/service.service/unbindProcess', params)
